<ng-container [formGroup]="searchForm" *ngIf="searchForm">
    <input for="floatingSelect"
           #input
           class="form-control example"
           (keydown)="onEnterKeyPress($event)"
           (blur)="onBlur()"
           formControlName="search" />
</ng-container>